import React from 'react';
import _map from 'lodash/map';
import _size from 'lodash/size';
import PropTypes from 'prop-types';
// Material UI
import { makeStyles } from '@material-ui/core/styles';
import MuiTimeline from '@material-ui/lab/Timeline';
import MuiTimelineConnector from '@material-ui/lab/TimelineConnector';
import MuiTimelineContent from '@material-ui/lab/TimelineContent';
import MuiTimelineDot from '@material-ui/lab/TimelineDot';
import MuiTimelineItem from '@material-ui/lab/TimelineItem';
import MuiTimelineOppositeContent from '@material-ui/lab/TimelineOppositeContent';
import MuiTimelineSeparator from '@material-ui/lab/TimelineSeparator';
// HOCs
import { withSize } from 'react-sizeme';
// Custom
import AppIcon from 'components/icons/AppIcon';
import Typography from '../Typography';

const useStyles = (width, labelWidth) => makeStyles((theme) => ({
  root: {
    padding: theme.spacing(1),
  },
  label: {
    minWidth: labelWidth,
    maxWidth: labelWidth,
    paddingTop: 14,
  },
  content: {
    maxWidth: `${width - labelWidth - 36 - theme.spacing(1) * 2}px`,
  },
}));

const Timeline = withSize({ refreshRate: 100, refreshMode: 'debounce' })(
  ({
    startItem, items, labelWidth, children, size: { width },
  }) => {
    const classes = useStyles(width, labelWidth)();

    // Start item
    const { iconId: startIconId, label: startLabel } = startItem || {};

    return (
      <MuiTimeline className={classes.root}>
        {startItem && (
          <MuiTimelineItem>
            <MuiTimelineOppositeContent className={classes.label}>
              <Typography type="adornment">
                {startLabel || ' '}
              </Typography>
            </MuiTimelineOppositeContent>
            <MuiTimelineSeparator>
              <MuiTimelineDot color="primary" variant="outlined">
                {startIconId && (
                  <AppIcon id={startIconId} defaultColor />
                )}
              </MuiTimelineDot>
              <MuiTimelineConnector />
            </MuiTimelineSeparator>
            <MuiTimelineContent />
          </MuiTimelineItem>
        )}
        {items && _map(items, ({
          id, label, iconId, content,
        }, index) => (
          <MuiTimelineItem key={id}>
            {label && (
            <MuiTimelineOppositeContent className={classes.label}>
              <Typography type="adornment">
                {label}
              </Typography>
            </MuiTimelineOppositeContent>
            )}
            <MuiTimelineSeparator>
              <MuiTimelineDot color="primary" variant="outlined">
                {iconId && (
                <AppIcon id={iconId} defaultColor />
                )}
              </MuiTimelineDot>
              {index < (_size(items) - 1) && (
              <MuiTimelineConnector />
              )}
            </MuiTimelineSeparator>
            {content && (
            <MuiTimelineContent className={classes.content}>
              {content}
            </MuiTimelineContent>
            )}
          </MuiTimelineItem>
        ))}
        {children}
      </MuiTimeline>
    );
  },
);

Timeline.propTypes = {
  startItem: PropTypes.shape({
    iconId: PropTypes.string,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  }).isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
      iconId: PropTypes.string,
      content: PropTypes.node,
    }),
  ),
  labelWidth: PropTypes.number,
  children: PropTypes.node,
  // From `withSize` HOC
  width: PropTypes.number,
};

Timeline.defaultProps = {
  startItem: null,
  items: null,
  labelWidth: 80,
  children: null,
  width: null,
};

export default React.memo(Timeline);



// WEBPACK FOOTER //
// ./components/core/timeline/Timeline.js